import * as requests from 'api/requests';
import { sendingAppFeedback, sendingAppFeedbackFailure, sendingAppFeedbackSuccess, sendingContactRequest, sendingContactRequestFailure, sendingContactRequestSuccess, sendingLinkFeedback, sendingLinkFeedbackFailure, sendingLinkFeedbackSuccess, sendingLinkRequest, sendingLinkRequestFailure, sendingLinkRequestSuccess } from 'redux/actions/feedback';
import { displayErrorSwal } from 'utilities/Validations';

export function sendAppFeedback(content) {
    return (dispatch) => {
        dispatch(sendingAppFeedback());

        return requests
            .sendAppFeedback(content)
            .then((data) => {
                dispatch(sendingAppFeedbackSuccess());
            })
            .catch((error) => {
                displayErrorSwal('An error occurred sending feedback, please try again later.')
                dispatch(sendingAppFeedbackFailure(error));
            });
    };
}

export function sendContactRequest(content) {
    return (dispatch) => {
        dispatch(sendingContactRequest());

        return requests
            .sendContactRequest(content)
            .then((data) => {
                dispatch(sendingContactRequestSuccess());
            })
            .catch((error) => {
                displayErrorSwal('An error occurred sending a contact request, please try again later.')
                dispatch(sendingContactRequestFailure(error));
            });
    };
}

export function sendLinkFeedback(content) {
    return (dispatch) => {
        dispatch(sendingLinkFeedback());

        return requests
            .sendLinkFeedback(content)
            .then((data) => {
                dispatch(sendingLinkFeedbackSuccess());
            })
            .catch((error) => {
                displayErrorSwal('An error occurred sending feedback, please try again later.')
                dispatch(sendingLinkFeedbackFailure(error));
            });
    };
}

export function sendLinkRequest(content) {
    return (dispatch) => {
        dispatch(sendingLinkRequest());

        return requests
            .sendLinkRequest(content)
            .then((data) => {
                dispatch(sendingLinkRequestSuccess());
            })
            .catch((error) => {
                displayErrorSwal('An error occurred sending a link request, please try again later.')
                dispatch(sendingLinkRequestFailure(error));
            });
    };
}

